import './Locations.css';

function SanFrancisco() {
  return (
    <div className="SanFrancisco">
      <h3>San Francisco</h3>
      
      <p>In the beginning there was the sea. And the sea was without form, and void; 
        and darkness was upon the face of the deep. And a light moved upon the face of the waters.</p>

      <p>Reflections of car headlights swimming along the Golden Gate strait.</p>

      <p>Fog creeps into the bay with tender feet, her thick and wild hair spreading 
        lazily over the waves. She shakes her mane and tendrils settle into the city,
         circling skyscrapers in a thick blanket. Wisps reach up to the starless night,
          longingly searching for the sliver of moon hidden behind dark clouds. Discouraged,
           she settles forlorn upon the water in thick heartache.</p>

      <p>The man is lost in the mist. He had dozed away in his algae-covered fishing 
        dinghy at sundown, lulled by the gentleness of the waves, but had awoken in 
        this uncertain hour by the faraway sound of tears. Nearly blind from the unnatural
         heavy mist, he tentatively moves around his dinghy, turning on the lamp at 
         the head of the boat. Peering into the dense body in front of him, he tries 
         in vain to discern familiar features. His fingertips reach tentatively into
          the damp air, out into the lonesome void of night.</p>

      <p>A kiss, soft as moonlight in spring, brushes against his hand, and he jerks
         back in surprise, falling over the bench in the middle of the boat and landing
          flat on his back feet stuck in the air. His boat creaks and moans irritably 
          at the sudden movement. Flipping around and scrambling back to his feet, he 
          warily moves back to the side of the boat and reaches out his hand again, 
          leaning forward over the railing. Cool fingers slip over and intertwine with 
          his own, and she wills her body to solidify from the surrounding fog, her 
          silhouette accentuated by the hazy light of the lamp. He lifts her from the 
          surface, lighter than air, and places her gently in the boat.</p>

      <p>They spent the remainder of the evening together, one healing heartbreak, the 
        other causing a deep love to form. From that day, each evening for nine months 
        he would venture out into the sea as the fog was rolling in and they would wrap 
        themselves in each other's embrace.</p>

      <p>On the first day of the tenth month since they had first met, she did not come 
        alone. She brought with her their newborn daughter whose hair was already as wild as her mother's.</p>

      <p><i>Take her, raise her amongst your kind.</i></p>
      <p>Won't you come with us?</p>
      <p><i>I cannot, but I will keep watch over you both.</i></p>
      <p>What about us?</p>
      <p><i>Go, the sun will rise soon.</i></p>
      <p>My love—</p>
      <p>But she was already fading as golden rays of light pierced through the mist.</p>

      <p>And so Cyane came into the world. At night, after she fell asleep, her father would 
        try to visit the fog again, and although the weather phenomenon would appear, the figure 
        in the mist would stay stubbornly away. After two years of nightly heartbreak, he finally 
        took Cyane and moved to the mountains of South Lake Tahoe, away from San Francisco, away 
        from the fog, to begin life anew.</p>
    </div>
  );
}

export default SanFrancisco;
